import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()({
    changeAddressLink: {
        textDecoration: "underline",
        cursor: "pointer",
    },
});
